import {cx as addStyles, css} from '@emotion/css';
import {theme} from '@remoov/remoov-components';
import React, {HTMLAttributes} from 'react';
import {DashboardCard, DashboardCardTitle, textBaseStyle} from './Common';

export type ItemSummaryCardProps = {
  collected: number | string;
  forSale: number | string;
  sold: number | string;
  auctioned: number | string;
  donated: number | string;
  recycled: number | string;
  className?: string;
};

export const ItemSummaryCard = ({
  collected,
  forSale,
  sold,
  auctioned,
  donated,
  recycled,
  className,
}: ItemSummaryCardProps) => (
  <DashboardCard className={className}>
    <DashboardCardTitle>Item Summary</DashboardCardTitle>
    <CategoriesContainer>
      <CategoryContainer>
        <CategoryTitle>COLLECTED</CategoryTitle>
        <CategoryValue>{collected}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>FOR SALE</CategoryTitle>
        <CategoryValue>{forSale}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>SOLD</CategoryTitle>
        <CategoryValue>{sold}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>AUCTIONED</CategoryTitle>
        <CategoryValue>{auctioned}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>DONATED</CategoryTitle>
        <CategoryValue>{donated}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>RECYCLED</CategoryTitle>
        <CategoryValue>{recycled}</CategoryValue>
      </CategoryContainer>
    </CategoriesContainer>
  </DashboardCard>
);
const containerBase = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
});
const CategoriesContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={addStyles(
      containerBase,
      css({
        alignItems: 'center',
        width: '100%',
        gap: '7%',
        [theme.mediaMaxWidth.small]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: theme.spacings.small,
        },
      }),
    )}
    {...args}
  />
);
const CategoryContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={addStyles(
      containerBase,
      css({
        flexDirection: 'column',
        gap: theme.spacings.xxsmall,
        marginBottom: theme.spacings.xsmall,
      }),
    )}
    {...args}
  />
);
const CategoryTitle = (args: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={addStyles(textBaseStyle, css({fontWeight: theme.font.medium}))} {...args} />
);
const CategoryValue = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={addStyles(textBaseStyle, css({fontWeight: theme.font.light}))} {...args} />
);
